module.exports = __webpack_public_path__ + "static/media/water_level_0.52a05952.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/icons/water_level_0.png
// module id = 311
// module chunks = 2